/* eslint-disable import/no-extraneous-dependencies */
import * as ExcelJS from 'exceljs'

const excelExport = async (columns, data, fileName, defaultRowHeight = 60) =>
	new Promise((resolve, reject) => {
		try {
			// export excel
			const workbook = new ExcelJS.Workbook()
			workbook.creator = `excel`
			workbook.created = new Date()
			//
			const sheet = workbook.addWorksheet(fileName)
			sheet.properties.defaultRowHeight = defaultRowHeight
			sheet.columns = columns
			sheet.getRow(1).eachCell(cell => {
				cell.style.font = {
					size: 12,
					bold: true,
				}
				cell.style.fill = {
					type: 'pattern',
					pattern: 'solid',
					fgColor: {
						argb: 'f8f9fc',
					},
				}
				cell.style.border = {
					top: { style: 'thin', color: { argb: '000000' } },
					left: { style: 'thin', color: { argb: '000000' } },
					right: { style: 'thin', color: { argb: '000000' } },
					bottom: { style: 'thin', color: { argb: '000000' } },
				}
			})

			data.forEach(el => {
				sheet.addRow(el)
			})

			workbook.xlsx.writeBuffer().then(resposneData => {
				const blob = new Blob([resposneData], {
					type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
				})
				const blobURL = URL.createObjectURL(blob)
				const link = document.createElement('a')
				link.href = blobURL
				link.download = `${fileName}.xlsx`
				link.innerHTML = 'Click here to download the file'
				link.click()
				link.remove()
				resolve(resposneData)
			})
		} catch (error) {
			reject(error)
		}
	})

export { excelExport }
